export const MetaData = {
    '1': 'QmQkjvkEAZKfnPV2uKR2jgYw3WK7bGwmkxn7Y4sPfm9yCw',

    '2': 'Qme9tKDJKs5vGPoVZkyCxzN4UCj5YDegcnUGQvPibrW3or',

    '3': 'QmZuhVvLGyy1BDmFzUrnPFwDDNUGDW5kC8pnjeBJpr2CX4',

    '4': 'QmfDi6tdX93BrKMWq1nnH5siFyCPGE4Vs9MAr1L7wd3ojd',

    '5': 'Qmbi26z8gi2nXBJcvDmR88zsb4s7oZkut6CZqGoqFudFMk',

    '6': 'QmarRW8M4Ynx3yCSzgBaUnY24bv3MEVTjJ9F2Mhk9QKT5q',

    '7': 'QmQ13uhtEVq4WRcYma23BmjTiJjr392ERxnhFvUeRhWsSA',

    '8': 'QmXbJVvCN1YcE4b62b1vyimy1stn2qYZy6RYfjJEFSvxbj',

    '9': 'QmX26KeAQXhcejFburvdMstZXraxdfprBnj8749q89Tk9F',

    '10': 'QmcLYiwei9WRQ8iwL87yrCjbfXNQndt5XLhv4nhwscH3y2',

    '11': 'QmXHbyk8MBtNxTzzbk2D33X117fLV1ApPnJkCvTQ1ZQWqV',

    '12': 'QmYcjdkHPGPXVWZQ21mC5Y6WmrQEqw4UnzxpUdp4L1PhnU',

    '13': 'QmNLxZTUS71sKiVT3G6ZE4rnnuHjoC1yVsnWALwRxQLZof',

    '14': 'QmXLhAqkxSjLpFLbrCkSCxtbNw73Jqh9CPoG24NwBjLwj7',

    '15': 'QmZLm3ACXEzpiHafhVvqwjnjBWPQKApgUJR1hLqvLE4N1M',

    '16': 'QmY17zEoqp8ALRg3EoMcuNTeFEAwk3BhpobPrSti3ahGDt',

    '17': 'QmUminU5GrRUyBWXHCEx5TMLiqNaMd6Lcs4rUzPsSRF5ui',

    '18': 'QmRSXn6jry9Nrv9ARGuGW8oR68Si3RdBWET14CpzbgMdBR',

    '19': 'Qmc71SZ6BQE857f8BQ4vcS7EQELfXVViMwtgMhsgd3HvkK',

    '20': 'QmNNiBCsiCCAbY82Q6Uu1K9Hgog5FDvSa4FZgkU392Ho1L',
}